import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17Z"
      fill="#FF2E00"
    />
    <G clipPath="url(#clip0_2936_2335)">
      <Path
        d="M17 5C10.3829 5 5 10.3829 5 17C5 23.6171 10.3829 29 17 29C23.6171 29 29 23.6171 29 17C29 10.3829 23.6171 5 17 5Z"
        fill="#F44336"
      />
      <Path
        d="M21.4194 20.0043C21.8103 20.3954 21.8103 21.0273 21.4194 21.4184C21.2244 21.6134 20.9684 21.7114 20.7123 21.7114C20.4563 21.7114 20.2003 21.6134 20.0053 21.4184L17.0004 18.4133L13.9954 21.4184C13.8004 21.6134 13.5444 21.7114 13.2884 21.7114C13.0323 21.7114 12.7763 21.6134 12.5813 21.4184C12.1904 21.0273 12.1904 20.3954 12.5813 20.0043L15.5864 16.9994L12.5813 13.9944C12.1904 13.6033 12.1904 12.9714 12.5813 12.5803C12.9724 12.1894 13.6043 12.1894 13.9954 12.5803L17.0004 15.5854L20.0053 12.5803C20.3964 12.1894 21.0283 12.1894 21.4194 12.5803C21.8103 12.9714 21.8103 13.6033 21.4194 13.9944L18.4143 16.9994L21.4194 20.0043Z"
        fill="#FAFAFA"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_2936_2335">
        <Rect width={24} height={24} fill="white" transform="translate(5 5)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
